export function chainLoader(src){
    
    src.forEach( async (url) => { await importScript(url); });
}

export function importScript(src, expressionToEvaluateAndReturn){

    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.async = true;
        script.src = src;
        script.addEventListener('load', (event)=>{
            if(expressionToEvaluateAndReturn){
                try{
                    let result = eval(expressionToEvaluateAndReturn);
                    resolve(result);
                } catch(error){
                    reject(error);
                }

            } else {
                resolve();
            }
        });
        script.addEventListener('error', () => reject('Error loading script "' + src + '"'));
        script.addEventListener('abort', () => reject('Script loading aborted for "' + src + '"'));
        document.head.appendChild(script);
    });    

}